import clsx from 'clsx';

export const loaderClasses = 'animate-pulse bg-input-disabled';

export const TextInputLoader = () => {
  return (
    <div
      className={clsx('h-[3.25rem] w-full', loaderClasses)}
    />
  );
};

export const LoadersList = ({
  amount,
  heightClasses = 'h-[3.25]',
}: { amount: number, heightClasses?: `h-${string}` }) => {
  return Array.from({
    length: amount,
  }).map((_, i) => (
    <div
      key={i}
      className={clsx(heightClasses, 'w-full', loaderClasses)}
    />
  ));
};
